export default __webpack_public_path__ + "static/media/avatar.24c2c708.jpg";